__turbopack_context__.v({
  "endOfFeed": "FeedLoader-module-scss-module__zQ03_q__endOfFeed",
  "feedLoadLimit": "FeedLoader-module-scss-module__zQ03_q__feedLoadLimit",
  "feedLoaderContainer": "FeedLoader-module-scss-module__zQ03_q__feedLoaderContainer",
  "loader": "FeedLoader-module-scss-module__zQ03_q__loader",
});
